// Mutations
export const SET_OPPORTUNITIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.opportunities.data = payload
    state.opportunities.lastUpdate = new Date()
  }
}
export const ADD_OPPORTUNITIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.opportunities.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.opportunities.data.push(data)
      }
    })
  }
}
export const SET_OPPORTUNITIES_LOADING = (state, payload) => {
  state.opportunities.loading = payload
}

export const SET_PRODUTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.produtos.data = payload
    state.produtos.lastUpdate = new Date()
  }
}
export const ADD_PRODUTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.produtos.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.produtos.data.push(data)
      }
    })
  }
}
export const SET_PRODUTOS_LOADING = (state, payload) => {
  state.produtos.loading = payload
}

export const SET_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clients.data = payload
    state.clients.lastUpdate = new Date()
  }
}
export const ADD_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clients.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clients.data.push(data)
      }
    })
  }
}
export const SET_CLIENTS_LOADING = (state, payload) => {
  state.clients.loading = payload
}
